import { Fragment } from 'react'

import type { PaginationMeta } from '@/types/api'

interface PaginationProps {
  meta: PaginationMeta
  onPageChange: (page: number) => void
}

export function Pagination({ meta, onPageChange }: PaginationProps) {
  const { currentPage, lastPage } = meta
  if (lastPage <= 1) return null

  const pages = Array.from({ length: lastPage }, (_, i) => i + 1).filter(
    (page) => page === 1 || page === lastPage || Math.abs(page - currentPage) <= 1,
  )

  return (
    <nav aria-label="Pagination">
      <ul className="pagination justify-content-end mb-0">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`.trim()}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
        </li>
        {pages.map((page, idx) => (
          <Fragment key={page}>
            {idx > 0 && pages[idx - 1] !== page - 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0">…</span>
              </li>
            )}
            <li className={`page-item ${page === currentPage ? 'active' : ''}`.trim()}>
              <button type="button" className="page-link" onClick={() => onPageChange(page)}>
                {page}
              </button>
            </li>
          </Fragment>
        ))}
        <li className={`page-item ${currentPage === lastPage ? 'disabled' : ''}`.trim()}>
          <button
            type="button"
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === lastPage}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  )
}
